import { Fragment, type ReactNode } from 'react';

function escapeRegExp(value: string) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function HighlightedSnippet({ text }: { text: string }) {
  const parts: string[] = [];
  let start = 0;
  for (let index = 0; index < text.length; index += 1) {
    if (text[index] !== '\u0002' && text[index] !== '\u0003') continue;
    if (index > start) parts.push(text.slice(start, index));
    parts.push(text[index]);
    start = index + 1;
  }
  if (start < text.length) parts.push(text.slice(start));

  const nodes: ReactNode[] = [];
  let marked = false;

  parts.forEach((part, index) => {
    if (part === '\u0002') {
      marked = true;
      return;
    }
    if (part === '\u0003') {
      marked = false;
      return;
    }
    if (part) {
      nodes.push(marked ? <mark key={index}>{part}</mark> : <Fragment key={index}>{part}</Fragment>);
    }
  });

  return nodes;
}

export function HighlightedPage({ text, terms }: { text: string; terms: string[] }) {
  const normalized = terms.filter(Boolean).sort((a, b) => b.length - a.length);
  if (!normalized.length) return text;

  const expression = new RegExp(`(${normalized.map(escapeRegExp).join('|')})`, 'gi');
  return text.split(expression).map((part, index) =>
    normalized.some((term) => term.toLocaleLowerCase('de-DE') === part.toLocaleLowerCase('de-DE'))
      ? <mark key={index}>{part}</mark>
      : <Fragment key={index}>{part}</Fragment>
  );
}
